module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "main"
    }
  }, [_c('svg', {
    attrs: {
      "id": "field",
      "width": "100%",
      "height": "100%",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.addCell($event)
      },
      "mousedown": function($event) {
        _vm.mousedown($event)
      },
      "mouseup": function($event) {
        _vm.mouseup($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragover($event)
      },
      "drop": function($event) {
        _vm.drop($event)
      }
    }
  }, [_c('g', {
    staticClass: "svg-viewport",
    attrs: {
      "fill": "none"
    }
  }, [_vm._l((_vm.population), function(cell) {
    return _c('rect', {
      staticClass: "cell",
      attrs: {
        "x": cell.coordinates.x,
        "y": cell.coordinates.y,
        "width": "5",
        "height": "5"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.killCell(cell)
        }
      }
    })
  }), _vm._v(" "), (_vm.isPatternDragged) ? _c('use', {
    attrs: {
      "x": _vm.patternX,
      "y": _vm.patternY,
      "xlink:href": "#pattern"
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('defs', [(_vm.isPatternDragged) ? _c('g', {
    attrs: {
      "id": "pattern"
    }
  }, _vm._l((_vm.selectedPattern.coordinates), function(coordinate) {
    return _c('rect', {
      staticClass: "cell",
      attrs: {
        "x": coordinate.x,
        "y": coordinate.y,
        "width": "5",
        "height": "5"
      }
    })
  })) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "zoom-control"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.zoomIn()
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetZoom()
      }
    }
  }, [_vm._v("Reset Zoom & Pan")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.zoomOut()
      }
    }
  }, [_vm._v("-")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67c291bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Field.vue
// module id = 104
// module chunks = 1